import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 text-lg font-medium text-foreground-950 md:text-xl">
          <span className="h-5 w-1 rounded-full bg-accent-500" />
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-primary-700 transition-colors hover:text-primary-500"
        >
          {moreLabel}
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-arrow-right-s-line text-base" />
          </span>
        </Link>
      )}
    </div>
  );
}